module.exports = __webpack_public_path__ + "img/mono-square.6b5cc670.svg";